// 第2张
const imgAll2 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642303928/a2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642845977/c2.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642303928/a2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642845977/c2.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725092257667/a2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725092747242/b2.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093141992/uk2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093604678/uk2.jpg',
    },
};
export const imgLocale2: any = {
    jp: imgAll2.JP,
    us: imgAll2.NA,
    ca: imgAll2.NA,
    br: imgAll2.NA,
    mx: imgAll2.NA,
    uk: imgAll2.UK,
    eu: imgAll2.EU,
    de: imgAll2.EU,
    fr: imgAll2.EU,
    it: imgAll2.EU,
    es: imgAll2.EU,
};
